// This component displays instructions on how to play the game.
import React from 'react';
import '../App.css';

const HowToPlay = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content how-to-play-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>How To Play</h2>
        <div className="instructions">
          <p>
            All game modes are word-guessing games. Your goal is to figure out the secret word using
            hints like images and riddles.
          </p>

          <h3>Letter colors (applies to the word games)</h3>
          <p>With each guess you submit:</p>
          <ul>
            <li>
              <strong>Green:</strong> The letter is in the correct position.
            </li>
            <li>
              <strong>Yellow:</strong> The letter is in the word but in a different position.
            </li>
            <li>
              <strong>Gray:</strong> The letter is not in the word.
            </li>
          </ul>

          <h3>Zoomed In (Classic)</h3>
          <p>
            <strong>Objective:</strong> guess the word from a zoomed-in photo. Words can be{' '}
            <strong>5 or 6 letters</strong> long.
          </p>
          <p>
            Each wrong guess makes the image zoom out a bit so you can see more details.
          </p>

          <h3>Unlimited</h3>
          <p>
            <strong>Objective:</strong> guess the <strong>5-letter</strong> word.
          </p>
          <p>
            You can keep playing round after round. Images and (optional) riddles can help — but
            sometimes they’re tricky and won’t instantly give the answer.
          </p>

          <h3>Generations</h3>
          <p>
            <strong>Objective:</strong> guess the <strong>5-letter</strong> word.
          </p>
          <p>
            This mode generates a brand-new <strong>AI image</strong> each round (it costs coins),
            so it’s <strong>sign-in required</strong>. Images and (optional) riddles may help — or
            they may mislead you, so use the letter colors to confirm your guesses.
          </p>

          <h3>Riddled-In</h3>
          <p>
            Instead of color tiles, you get a <strong>riddle</strong> for a secret word. You type
            guesses and you’ll see a <strong>percentage</strong> for each guess — the closer you
            are, the higher it is. Hit <strong>100%</strong> to solve it.
          </p>
          <p>
            There are powerups (like hint images) that may help, but you still need to use the
            riddle + the percentage feedback to narrow it down.
          </p>

          <p>Good luck and have fun!</p>
        </div>
      </div>
    </div>
  );
};

export default HowToPlay; 